{
    "translation": {
        "invoices": {
            "note": "Kära kund, om du är en kortbetalande kund, vänligen bortse från denna faktura."
        },
        "flowPicker": {
            "title": "Är du ny eller befintlig Flex-kund?",
            "newCustomer": "Jag vill bli Flex-kund",
            "existingCustomer": "Jag har en Flex-prenumeration",
            "nextButton": "Gå vidare"
        },
        "lisaAnd": {
            "plans": {
                "selectSubscription": "Välj prenumeration",
                "description": "",
                "VALUE": {
                    "title": "Flex 24 månader",
                    "description": "Byt eller avsluta efter 24 mån"
                },
                "FLEX": {
                    "title": "Full Flexibilitet",
                    "description": "Byt eller avsluta när du vill",
                    "priceDescription": "i {{months}} mån, därefter {{price}}"
                },
                "disclaimer": "Priset gäller vid godkänt inbyte i angivet skick",
                "welcomeMessage": {
                    "title": "",
                    "paragraphs": [
                        "Samsung Flex är ett samarbete mellan Samsung och Lisa& som innebär att du har möjlighet att hyra Samsungprodukter av Lisa&. Särskilda villkor för Samsung Flex från Samsung respektive Lisa& gäller."
                    ]
                }
            },
            "cart": {
                "priceFor": "{{price}} \nfor {{months}} months",
                "monthlyCost": "Din månadskostnad",
                "accessories": "Tillbehör",
                "prepayToday": "Att betala idag",
                "prepayTodayDisclaimer": "{{months}} månad + Tillbehör",
                "showDiscount": "Visa rabattdetaljer",
                "VALUE": {
                    "planName": "med Flex 24 månader"
                },
                "FLEX": {
                    "planName": "med Full Flexibilitet"
                },
                "totalMonthlyDiscount": "<0>Total månadsrabatt (1-{{months}}) <1></1></0>",
                "totalMonthlyDiscountIncludesBoth": "<0>Rabatten inkluderar både det estimerade trade-in värdet och rabatter.</0>"
            }
        },
        "general": {
            "readMore": "Läs mer här",
            "images_zero": "",
            "images_one": "1 image",
            "images_other": "{{count}} bilder",
            "edit": "Redigera",
            "cancel": "Avbryt",
            "save": "Spara",
            "close": "Stäng",
            "view": "Visa och hantera",
            "back": "Tillbaka",
            "errors": {
                "required": "Detta fält är obligatoriskt"
            }
        },
        "svea": {
            "genericDiscount": "Rabatt",
            "tradeinSubsidy": "Uppdaterat inbytesvärde efter Foxway-certifierad gradering",
            "tradeinSubsidyPlaceholderReversal": "Trade-in rabatt justering",
            "tradeinName": "Trade-in rabatt",
            "upfrontPaymentProduct": "Förskottsbetala: ",
            "upfrontPaymentProductDiscount": "Förskottsbetala: ",
            "upfrontPaymentTradeInDiscount": "Förskottsbetala: ",
            "reversal": "Annullering: "
        },
        "header": {
            "back": "Tillbaka",
            "backLink": "https://shop.samsung.com/se/cart",
            "help": "Vid eventuella frågor, ring på 077-140 10 44",
            "helpLink": "Mobile: 077-140 10 44",
            "language": {
                "options": {
                    "fi-FI": "Finnish",
                    "sv-SE": "Swedish",
                    "no-NO": "Norwegian",
                    "nb-NO": "Norwegian",
                    "da-DK": "Danish"
                },
                "label": "Välj språk",
                "labelDescription": "Välj språk för att fortsätta",
                "selectLabel": "Språkväljare"
            },
            "toggleLabel": "Menu",
            "home": "Hem",
            "login": "Logga in på ditt Samsung Flex konto",
            "loginSubtitle": "Välj inloggningssätt",
            "loginButton": "Logga in",
            "logOut": "Logga ut",
            "subscriptions": "Mina enheter",
            "invoices": "Fakturor",
            "offers": "Erbjudanden",
            "account": "Mitt konto"
        },
        "banner": {
            "title": "Det nya sättet att ha Samsung Galaxy",
            "subTitle": "Passion för teknik, med omtanke"
        },
        "footer": {
            "language": "",
            "languageLink": "",
            "backToTop": "Tillbaka till början",
            "topNote": {
                "text": "För frågor om programmet eller prata med kundtjänst, vänligen kontakta Samsung på: 0771-40 10 44",
                "button": {
                    "text": "Ring kundsupport 0771-40 10 44",
                    "url": "tel:0771-40 10 44"
                }
            },
            "copyright": "Copyright© 1995-{{currentYear}} Samsung. Med ensamrätt.",
            "termsAndConditions": "Se fullständiga <1>villkor</1>",
            "termsAndConditionsLink": "https://resellers.foxway.com/subscriptionterms-se",
            "social": {
                "title": "Följ oss på",
                "items": []
            },
            "terms": [],
            "items": [
                {
                    "title": "Support",
                    "links": [
                        {
                            "text": "0771-40 10 44",
                            "url": "tel:0771-40 10 44"
                        },
                        {
                            "text": "Mån - Fre | 08:00 - 18:00"
                        },
                        {
                            "text": "Lör | Stängt"
                        },
                        {
                            "text": "Sön | Stängt"
                        },
                        {
                            "text": "Samsung Support",
                            "url": "https://www.samsung.com/se/support/contact/#contactinfo"
                        }
                    ]
                },
                {
                    "title": "Om Samsung Flex",
                    "text": "Lisa& erbjuder privatpersoner möjligheten att hyra produkter som Samsung Electronics Nordic AB gör tillgängliga inom ramen för Samsung Flex. I samband med beställningen kan kunden även köpa vissa andra produkter av Lisa&.",
                    "links": [
                        {
                            "text": "För mer information, se https://www.samsung.com/se/flex",
                            "url": "https://www.samsung.com/se/flex",
                            "target": "_blank"
                        }
                    ]
                },
                {
                    "title": "Om Lisa&",
                    "text": "Bolagsnamn: Lisa & friends AB\nOrganisationsnummer: 559315-0955\nPostadress: c/o United Spaces, Drottninggatan 32, 111 51 Stockholm, Sverige\nRegistreringsnummer för mervärdesskatt: SE559315095501"
                },
                {
                    "title": "Om Samsung",
                    "text": "Bolagsnamn: Samsung Electronics Nordic AB\nOrganisationsnummer: 556445-4345\nKontaktinformation: https://www.samsung.com/se/support/contact/\nBesöksadress: Torshamnsgatan 48, 164 40 Kista, Sweden\nPostadress: Box 1235, 164 28 Kista, Sweden\nRegistreringsnummer för mervärdesskatt: SE5564454345-01",
                    "links": []
                }
            ]
        },
        "portalFooter": {
            "backToTop": "Tillbaka",
            "copyright": "Kundportalen och tillhörande tjänster inom Samsung Flex tillhandahålls av Foxway. Copyright© 1995-{{currentYear}} Samsung. Med ensamrätt.",
            "items": [
                {
                    "title": "Support",
                    "links": [
                        {
                            "text": "0771-40 10 44",
                            "url": "tel:0771-40 10 44"
                        },
                        {
                            "text": "Mån - Fre | 08:00 - 18:00"
                        },
                        {
                            "text": "Lör | Stängt"
                        },
                        {
                            "text": "Sön | Stängt"
                        },
                        {
                            "text": "Samsung Support",
                            "url": "https://www.samsung.com/se/support/contact/#contactinfo"
                        }
                    ]
                },
                {
                    "title": "Om Samsung Flex",
                    "text": "Lisa& erbjuder privatpersoner möjligheten att hyra produkter som Samsung Electronics Nordic AB gör tillgängliga inom ramen för Samsung Flex. I samband med beställningen kan kunden även köpa vissa andra produkter av Lisa&.",
                    "links": [
                        {
                            "text": "För mer information, se https://www.samsung.com/se/flex",
                            "url": "https://www.samsung.com/se/flex",
                            "target": "_blank"
                        }
                    ]
                },
                {
                    "title": "Om Lisa&",
                    "text": "Bolagsnamn: Lisa & friends AB\nOrganisationsnummer: 559315-0955\nPostadress: c/o United Spaces, Drottninggatan 32, 111 51 Stockholm, Sverige\nRegistreringsnummer för mervärdesskatt: SE559315095501"
                },
                {
                    "title": "Om Samsung",
                    "text": "Bolagsnamn: Samsung Electronics Nordic AB\nOrganisationsnummer: 556445-4345\nKontaktinformation: https://www.samsung.com/se/support/contact/\nBesöksadress: Torshamnsgatan 48, 164 40 Kista, Sweden\nPostadress: Box 1235, 164 28 Kista, Sweden\nRegistreringsnummer för mervärdesskatt: SE5564454345-01",
                    "links": []
                }
            ]
        },
        "plans": {
            "tradeInTitle": "Ytterligare rabatt efter inbyte:",
            "tradeIn": "{{amount}} / mån i {{duration}} mån",
            "closeModal": "Stäng",
            "selectSubscription": "Samsung Flex - det nya sättet att ha Samsung Galaxy",
            "description": "Med Samsung Flex kan du ha Samsung Galaxy utan att äga, alltid för en fast månadskostnad. Du kan välj mellan friheten att byta, uppgradera och avsluta när du vill, eller få en lägre månadskostnad med 24 månaders bindningstid. När du uppgraderar eller avslutar, får din Samsung Galaxy ett nytt liv eller återvinns. Flex är ett samarbete mellan Samsung och Lisa& som innebär att att du får möjligheten att hyra enheter från Lisa&.",
            "plans": {
                "EMPTY": {
                    "title": "-",
                    "description": "",
                    "descriptionOne": "",
                    "descriptionTwo": "",
                    "descriptionThree": ""
                },
                "FLEX": {
                    "title": "Full flexibilitet",
                    "description": "",
                    "descriptionOne": {
                        "title": "Byt, uppgradera och avsluta när du vill",
                        "tooltip": ""
                    },
                    "descriptionTwo": {
                        "title": "Tillgång till swap service",
                        "tooltip": "",
                        "modal": {
                            "trigger": "",
                            "paragraphs": [
                                {
                                    "title": "",
                                    "content": ""
                                },
                                {
                                    "title": "",
                                    "content": ""
                                }
                            ]
                        }
                    },
                    "descriptionThree": {
                        "title": "En fast månadskostnad",
                        "tooltip": "",
                        "modal": {
                            "trigger": "",
                            "paragraphs": [
                                {
                                    "title": "",
                                    "content": ""
                                },
                                {
                                    "content": ""
                                }
                            ]
                        }
                    },
                    "accordion": {
                        "title": "Full flexibilitet",
                        "paragraphs": [
                            {
                                "title": "",
                                "content": "Med Full Flexibilitet har du friheten att själv välja när du vill byta eller uppgradera din enhet eller avsluta tjänsten."
                            },
                            {
                                "title": "Samsung Galaxy till en fast månadskostnad",
                                "content": "För en fast månadskostnad får du tillgång till den Samsung Galaxy du väljer, så länge du vill ha den."
                            },
                            {
                                "title": "Byt eller uppgradera när du vill",
                                "content": "Det är enkelt att byta eller uppgradera med Full Flexibilitet. Beställ först din nya Samsung Galaxy på samsung.com. Din nya enhet levereras hem tillsammans med en returetikett för din gamla enhet. \nDu behöver aldrig vara utan din Samsung Galaxy."
                            },
                            {
                                "title": "Avsluta när du vill",
                                "content": "När du valt att avsluta skickar Lisa& en returetikett till dig som du använder för att skicka tillbaka enheten. Enheten behöver vara Lisa& tillhanda inom 14 dagar efter att tjänsten avslutats. I de fall enheten inte returneras inom angiven tid anses uppsägningen vara ogiltig och fakturering av tjänsten återupptas."
                            },
                            {
                                "title": "Om din enhet skadas",
                                "content": "Inom ramen för Samsung Flex erbjuds en Swap Service, vilket innebär att du för oavsiktliga tapp- och vattenskador betalar en begränsad skadeavgift för en ersättningsenhet.\n Du anmäler din skada via kundportalen där Lisa& bedömmer om skadan kvalificerar dig för Swap Service. Vid godkänt skadeärende kommer Lisa& skicka en ersättningsenhet till dig tillsammans med ett returkit för din skadade enhet. Den skadade enheten ska vara Lisa& tillhanda senast 14 dagar efter att du har fått din ersättningsenhet.\n Om din enhet blir stulen, försvinner eller förstörs på annat sätt än den skada som kvalificeras för Swap Service blir du skyldig att ersätta Lisa& för den skada som orsakats.\n Lisa& förbehåller sig rätten att erbjuda en refurbished ersättningsenhet. För fullständiga villkor se https://resellers.foxway.com/subscriptionterms-se."
                            },
                            {
                                "title": "Inbyte och rabatt",
                                "content": "Som ny Samsung Flex-kund kan du välja att byta in din gamla telefon. Med Full Flexibilitet fördelas inbytesvärdet och eventuella extra rabatter över 12 månader (eller längre om rabatten överstiger 12 månadsavgifter). Rabatten överförs till den nya enheten vid uppgradering eller byte av enhet."
                            },
                            {
                                "title": "Tillbehör",
                                "content": "Tillsammans med Samsung Flex kan du köpa tillbehör för max 5700 kronor. De köps då av vår partner Lisa&."
                            }
                        ]
                    },
                    "priceDescription": "{{basePrice}} efter {{months}} mån"
                },
                "VALUE": {
                    "title": "24 månader",
                    "descriptionOne": {
                        "title": "Lägre månadskostnad med 24 månaders bindningstid",
                        "tooltip": ""
                    },
                    "descriptionTwo": {
                        "title": "Uppgradera eller lämna tillbaka vid periodens slut",
                        "tooltip": "",
                        "modal": {
                            "trigger": "",
                            "paragraphs": [
                                {
                                    "title": "",
                                    "content": ""
                                },
                                {
                                    "title": "",
                                    "content": ""
                                }
                            ]
                        }
                    },
                    "descriptionThree": {
                        "title": "Tillgång till swap service",
                        "tooltip": "",
                        "modal": {
                            "trigger": "",
                            "paragraphs": [
                                {
                                    "title": "",
                                    "content": ""
                                },
                                {
                                    "content": ""
                                }
                            ]
                        }
                    },
                    "accordion": {
                        "title": "24 Månader",
                        "paragraphs": [
                            {
                                "title": "",
                                "content": "Med 24 Månader betalar du ett lägre pris för att ha en Samsung Galaxy. Efter 24 månader kan du välja att uppgradera eller avsluta Samsung Flex och returnera enheten."
                            },
                            {
                                "title": "Samsung Galaxy till en fast månadskostnad",
                                "content": "För en fast månadskostnad får du tillgång till den Samsung Galaxy du väljer, under 24 månader."
                            },
                            {
                                "title": "Uppgradera eller avsluta efter 24 månader",
                                "content": "När din bindningstid närmar sig slutet blir du kontaktad för att göra ditt val. Det är enkelt att byta eller uppgradera med Samsung Flex. \nBeställ först din nya Samsung Galaxy på samsung.com. Din nya enhet levereras hem tillsammans med en returetikett för din gamla enhet. \nDu behöver aldrig vara utan din Samsung Galaxy när du uppgraderar. \nOm du väljer att avsluta tjänsten skickas enbart en returetikett. Enheten måste vara Lisa& tillhanda senast 14 dagar efter att din bindningstid löpt ut. Om du inte lämnar tillbaka enheten i tid har Lisa& rätt att kräva en avgift som motsvarar Enhetens marknadsvärde, vilket fastställs av Lisa&."
                            },
                            {
                                "title": "Om din enhet skadas",
                                "content": "Inom ramen för Samsung Flex erbjuds en Swap Service, vilket innebär att du för oavsiktliga tapp- och vattenskador betalar en begränsad skadeavgift för en ersättningsenhet.\n Du anmäler din skada via kundportalen där Lisa& bedömmer om skadan kvalificerar dig för Swap Service. Vid godkänt skadeärende kommer Lisa& skicka en ersättningsenhet till dig tillsammans med ett returkit för din skadade enhet. Den skadade enheten ska vara Lisa& tillhanda senast 14 dagar efter att du har fått din ersättningsenhet.\n Om din enhet blir stulen, försvinner eller förstörs på annat sätt än den skada som kvalificeras för Swap Service blir du skyldig att ersätta Lisa& för den skada som orsakats.  Lisa& förbehåller sig rätten att erbjuda en refurbished ersättningsenhet. För fullständiga villkor se https://resellers.foxway.com/subscriptionterms-se."
                            },
                            {
                                "title": "Inbyte och rabatt",
                                "content": "Som ny Samsung Flex-kund kan du välja att byta in din gamla telefon. För 24 Månader fördelas inbytesvärdet och eventuella extra rabatter över 24 månader."
                            },
                            {
                                "title": "Tillbehör",
                                "content": "Tillsammans med Samsung Flex kan du köpa tillbehör för max 5700 kronor. De köps då av vår partner Lisa&."
                            }
                        ]
                    }
                }
            },
            "selected": "Ditt val",
            "select": "Välj",
            "minimumTotalCost": "Minsta totalkostnad\n{{cost}}"
        },
        "sign": {
            "acceptTermsLabel": "Skicka mig marknadsföringsinformation",
            "acceptTerms": "Jag samtycker till att Samsung Electronics Nordic AB skickar mig information om Samsungs produkter och tjänster. För information om behandlingen av dina personuppgifter <1>se här</1>.",
            "acceptTermsLink": "https://www.samsung.com/se/info/privacy/",
            "title": "Personlig information",
            "firstName": "Förnamn",
            "lastName": "Efternamn",
            "email": "Email",
            "phone": "Telefonnummer",
            "postalCode": "Postnummer",
            "address": "Adress",
            "city": "Ort",
            "errors": {
                "firstName": "Ogiltig Förnamn",
                "lastName": "Ogiltig Efternamn",
                "lastNameTooBig": "Stöd för max 40 tecken. Var snäll och ta bort eventuella mellannamn och andra namn som inte används i dagligt bruk.",
                "firstNameTooBig": "Stöd för max 40 tecken. Var snäll och ta bort eventuella mellannamn och andra namn som inte används i dagligt bruk.",
                "email": "Ogiltig Email",
                "phone": "Ogiltig Telefonnummer",
                "postalCode": "Ogiltig Postnummer",
                "address": "Ogiltig Adress",
                "city": "Ogiltig Stad"
            },
            "steps": {
                "yourInfo": "Din info",
                "sign": "Signera",
                "confirmation": "Bekräftelse"
            },
            "delivery": "Leverans",
            "differentShippingAddress": "Min leveransadress skiljer sig från min fakturaadress",
            "deliveryMethods": {
                "se-hd-parcel-postnord-mx": {
                    "name": "Kostnadsfri hemleverans med Postnord",
                    "description": "",
                    "cartTitle": "Kostnadsfri hemleverans med Postnord",
                    "price": "Kostnadsfri"
                },
                "se-sena-hd-parcel-postnord": {
                    "name": "Hemleverans med Postnord",
                    "description": "Normal leveranstid är 1-5 vardagar, men kan vara längre för vissa postnummer.",
                    "cartTitle": "Hemleverans med Postnord",
                    "price": "Kostnadsfri"
                },
                "no-sena-hd-mxparcel-bring": {
                    "name": "Levering med Bring",
                    "description": "Normal leveringstid  er 1-5 virkedager",
                    "cartTitle": "Levering med Bring",
                    "price": "Gratis"
                },
                "no-sena-hd-parcel-dhl": {
                    "name": "Hjemlevering (pakke) - DHL",
                    "description": "Leveringstid ved hjemlevering (pakke) er 1-5 arbeidsdager. \nYtterligere leveringstid til visse postnumre kan påløpe.\nTransportøren meddeler deg via SMS under transporten med \nanslått leveringsdato og tid.",
                    "cartTitle": "DHL Express hemleverans",
                    "price": "Kostnadsfri"
                },
                "no-sena-pick-up-point": {
                    "name": "Fremsending - Bring",
                    "description": "I hovedsak 1–3 virkedager avhengig av strekning.\n4–5 dager til enkelte destinasjoner. \nE-varsling (sms/e-post) uten tillegg i prisen forutsetter \nat vi har mobilnummer eller e-postadresse. ",
                    "cartTitle": "Bring pickup",
                    "price": "Kostnadsfri"
                },
                "dk-sena-hd-parcel-postnord": {
                    "name": "Hjemmelevering (pakker) - Postnord",
                    "description": "Levering inden for 1-5 hverdage.\nDer kan være længere leveringstid ved levering til visse \npostnumre. \nTransportøren giver dig besked via SMS under transporten med \nanslået leveringsdato og -tidspunkt.",
                    "cartTitle": "Postnord hemleverans",
                    "price": "Kostnadsfri"
                },
                "fi-sena-hd-parcel-postnord": {
                    "name": "Kotiinkuljetus (paketti) – Postnord",
                    "description": "Toimitusaika 1-5 arkipäivää.\nToimitusaika saattaa olla pidempi tiettyjen postinumeroiden.\nLiikenteenharjoittajan tulee ilmoittaa sinulle tekstiviestitse \narvioitu toimituspäivä ja -aika kuljetukselle.",
                    "cartTitle": "Postnord hemleverans",
                    "price": "Kostnadsfri"
                }
            }
        },
        "authStep": {
            "title": "Logga in med Bank-ID",
            "subtitle": "Logga in på ditt Flexkonto med bank-ID för att se dina Flex-enheter och välja enhet att uppgradera, eller att lägga till en enhet om du önskar det.",
            "authenticationMethod": "Autentiseringsmetod",
            "termsLink": "https://www.foxway.com/sv/integritetspolicy/",
            "pepTerms": "Härmed bekräftar jag att jag inte är en politisk utsatt person (PEP), och inte är en familjemedlem eller känd medarbetare till en politisk utsatt person.",
            "loginWith": "Logga in med Bank-ID"
        },
        "validationStep": {
            "title": "Kreditevaluering",
            "subtitle": "För att vi ska kunna behandla din ansökan behöver vi göra en kreditevaluering. Vänligen följ instruktionerna nedan för att fortsätta.",
            "loadingText": "Vi kör kreditevalueringen, det tar ett par minuter. Vänligen vänta, du kommer automatiskt att omdirigeras till nästa steg."
        },
        "creditCheckStep": {
            "title": "Credit check",
            "subtitle": "We need to run a credit check",
            "terms": "I accept that my information will be submitted to <1>lorem ipsum dolor sit</1> for credit check report.",
            "termsLink": "https://www.foxway.com/sv/integritetspolicy/",
            "personalNumber": "Personal number",
            "errors": {
                "personalNumber": "Invalid personal number"
            }
        },
        "existingSubscriptionStep": {
            "title": "Din Flex-prenumeration",
            "description": "Vill du uppgradera en befintlig enhet eller lägga till en ny?",
            "buttonText": "Lägg till en ny Flex-enhet",
            "infoText": "",
            "flexTitle": "Full Flexibilitet",
            "valueTitle": "24 månader",
            "eligibleFrom": "Kan uppgradera från och med: <bold>{{date}}</bold>",
            "planMismatchDisclaimer": "Can only be upgraded into <bold>{{name}}</bold>",
            "activeFrom": "Aktiv från: <bold>{{date}}</bold>",
            "upgrade": "Uppgradera",
            "upgradeNotEligible": {
                "date": "Det är inte möjligt att uppgradera ännu. Se datumet ovan för när du kan uppgradera",
                "contactSupport": "Uppgradering är inte möjlig. Vänligen kontakta kundsupport.",
                "pendingUpgrade": "Denna prenumeration har redan en signerad uppgradering.",
                "activeClaim": "Det går inte att uppgradera på grund av ett pågående supportärende.",
                "deviceNotReturned": "Det går inte att uppgradera. Vi väntar på en annan enhet från dig.",
                "paymentPending": "Denna prenumeration har redan en signerad uppgradering med en väntande betalning. Du kan fortsätta här: ",
                "link": "link"
            }
        },
        "cart": {
            "disclaimer": "Inbytesvärdet är ett estimat. Rabatten fastställs och läggs till när inbytet är slutfört.",
            "tradeInMonthlyEstimate": "Månadskostnad efter inbyte",
            "tradeInTitle": "Samsung Trade-in",
            "tradeInValue": "Inbytesvärde",
            "tradeInMonthlyDiscount": "Månatlig trade-in rabatt i {{duration}} månader",
            "prepayToday": "Belopp att betala idag",
            "prepay": "Betala {{months}} månad idag",
            "discountDuration": "rabatt i {{months}} mån",
            "includesDiscount": "inklusive din rabatt {{discount}}",
            "cart": "Varukorg",
            "overview": "Översikt",
            "oneTimeCost": "Engångskostnad",
            "oneTimeCostAccessories": "Engångskostnad - Tillbehör",
            "seeDetailsBelow": "Se detaljer nedan",
            "authentication": "Bekräfta",
            "reviewAndSign": "Granska och signera",
            "continue": "Fortsätt",
            "paymentMethod": "Betalningsmetod",
            "invoice": "Faktura",
            "minimumTotalCost": "Minsta totalkostnad",
            "monthlyCost": "Månadskostnad",
            "monthlyCostWithoutDiscount": "Ordinarie månadskostnad",
            "generalDiscount": "Rabatt",
            "specialPriceTitle": "Första {{specialPriceLength}} månaderna, därefter {{priceGross}} {{currencyMonthly}}",
            "creditCheck": "Run credit check",
            "fraudProtection": "Vänta",
            "emptyText": "Vänligen välj din prenumerationstyp först.",
            "noticeText": "Genom att lägga till min betalningsmetod accepterar jag att Lisa& automatiskt och i förväg kan debitera alla kostnader som ska betalas till Lisa&."
        },
        "currency": {
            "perMonth": "mån",
            "feeForMonths": "{{fee}} i {{months}} mån"
        },
        "errorPages": {
            "accessory": {
                "title": "Den högsta totala tillbehörskostnaden är överskriden.",
                "button": "Tillbaka till varukorgen",
                "content": "<1><2>Tillsammans med din Samsung Flex enhet kan du köpa andra produkter för max 5700 kronor. Du har tillbehör i din varukorg som överstiger det beloppet och behöver därmed lägga en separat beställning med en annan betalmetod för dessa.</2></1>"
            },
            "general": {
                "title": "Något blev fel",
                "button": "Tillbaka till varukorgen",
                "content": "<1><2>Något gick fel, vänligen försök igen</2></1>"
            },
            "auth": {
                "title": "Något blev fel",
                "button": "Tillbaka till varukorgen",
                "content": "<1><2>Något gick fel, vänligen försök igen</2></1>"
            },
            "creditCheck": {
                "title": "Kreditupplysning Ej godkänd",
                "button": "Tillbaka till varukorgen",
                "contentFailed": "Din ansökan har avslagits då den inte uppfyller vår finansieringspartners kriterier för denna produkt. För mer information är du välkommen att kontakta vår kundsupport.",
                "contentTryAgain": "Din ansökan har avslagits eftersom den bank eller det konto du valde inte verkar vara ditt huvudkonto. Gå tillbaka och ansök med ditt primära bankkonto."
            }
        },
        "errors": {
            "generic": "Något gick fel, försök igen",
            "authenticationError": "Obehörig tillgång",
            "nicknameChangeError": "Smeknamn måste vara mellan 1 och 40 tecken",
            "scrive": {
                "authenticationError": "Något gick fel vid autentisering. Försök igen."
            },
            "svea": {
                "general": "",
                "underAge": "",
                "overAge": "",
                "numberOfAllowedSubscriptions": ""
            }
        },
        "portal": {
            "fraudulentCustomer": "Du har obetalda fakturor.",
            "payingIssuesCustomer": "Du har obetalda fakturor.",
            "dashboard": {
                "title": "Välkommen, "
            },
            "invoiceStatus": {
                "due": "Obetald",
                "allPaid": "Allt är betalt!",
                "dueOn": "Nästa faktura ska betalas senast: <2>{{date}}</2>.",
                "nextPayment": "Nästa faktura ska betalas senast: <2>{{date}}</2>.",
                "noNextPayment": "Ingen nästa betalning.",
                "button": "Visa fakturor"
            },
            "products": {
                "nickname": "{{firstName}}s enhet"
            },
            "invoice": {
                "status": {
                    "outstanding": "Obetald",
                    "partiallyPaid": "Delvis betald",
                    "paid": "Allt är betalt!",
                    "terminated": "Avslutad",
                    "unknown": "Okänd",
                    "credited": "Krediteras"
                }
            },
            "invoices": {
                "title": "Fakturor",
                "tableHeader": ["Faktura ID", "Beskrivning", "Period", "Förfallodatum", "Summa", "Status"],
                "viewInvoice": "Visa faktura",
                "viewInvoices": "Se fakturor",
                "loadMore": "Ladda mer",
                "accordion": {
                    "title": "Hur sätter jag upp autogiro?",
                    "text": "Skaffa autogiro för enklare betalning av fakturan. Ansök via din bank."
                },
                "status": {
                    "outstanding": "Försenad",
                    "partiallyPaid": "Delvis betald",
                    "paid": "Betalt",
                    "terminated": "Avslutad",
                    "unknown": "Okänd"
                },
                "noInvoices": "Inga fakturor"
            },
            "billingAlert": {
                "generic": {
                    "before": "Din betalningsmetod håller på att gå ut. ",
                    "link": "Uppdatera betalningsmetod",
                    "after": ""
                },
                "detailed": {
                    "before": "Din betalningsmetod är på väg att löpa ut. För att kunna fortsätta använda våra tjänster efter {{dueDate}}, vänligen ",
                    "link": "uppdatera din betalningsmetod",
                    "after": "."
                }
            }
        },
        "profile": {
            "title": "Mitt konto",
            "contactInformation": {
                "title": "Kontaktinformation",
                "firstName": "Förnamn",
                "lastName": "Efternamn",
                "email": "Email",
                "phone": "Telefon"
            },
            "billingInformation": {
                "title": "Faktureringsinformation",
                "card": "Kort",
                "expires": "Upphör att gälla",
                "updatePaymentMethod": "Uppdatera betalningsmetod",
                "methodUpdateDescription": "Uppdatering av betalningsmetod",
                "noInfo": "Ingen faktureringsinformation tillgänglig"
            },
            "address": {
                "title": "Adress",
                "postalCode": "Postnummer",
                "address": "Adress",
                "city": "Ort",
                "saveButton": "Spara adress"
            },
            "notificationPreferences": {
                "marketingModal": {
                    "title": "Skicka mig marknadsföringsinformation",
                    "content": "Jag samtycker till att Samsung Electronics Nordic AB skickar mig information om Samsungs produkter och tjänster.  För information om behandlingen av dina personuppgifter se <a href=\"https://www.samsung.com/se/info/privacy/\">här</a>"
                },
                "title": "Notifikationer",
                "marketingEmails": "Marknadsföring",
                "marketingEmailsLabel": "Skicka mig marknadsföringsinformation och specialerbjudanden"
            },
            "contactInformationDisclaimer": {
                "title": "Din kontaktinformation",
                "card": {
                    "title": "Din kontaktinformation",
                    "description": "Din kontaktinformation registrerades vid ordertillfället. Kontakta kundservice om du behöver uppdatera dina uppgifter.\n0771-40 10 44",
                    "link": "",
                    "linkUrl": ""
                }
            }
        },
        "offers": {
            "title": "Erbjudanden"
        },
        "upgrade": {
            "title": "Uppgradera"
        },
        "faq": {
            "title": "Frequently Asked Questions",
            "items": [
                {
                    "id": "samsung-flex",
                    "label": "What is Samsung Flex",
                    "children": "Samsung Flex is a service for you who would rather have a fixed monthly cost and regularly keep yourself updated instead of buying your Samsung Galaxy separately. Samsung Flex is available in two variants, Full Flexibility which gives you the freedom to change, upgrade or terminate whenever you want or 24 months where you pay a lower monthly cost and have your phone a little longer. Access to swap service applies to both."
                },
                {
                    "id": "samsung-flex-vs-buying",
                    "label": "How is Samsung Flex different from buying a device outright or in installments?",
                    "children": "..."
                }
            ]
        },
        "subscription": {
            "tradeInReimbursement": "Återbetalning av återstående inbytesbelopp",
            "flexSubscriptionFee": "Flex abonnemangsavgift",
            "depositAndAccessoryPayment": "Deposition och tillbehörsbetalning",
            "upfrontPayment": "Betala tillbehör & de första {{months}} månaderna",
            "endedDate": "Avslutade <1></1>",
            "upgradeFrom": "Kan uppgraderas från <1></1>",
            "ended": "Avslutade",
            "contractSigned": "Avtal signerades",
            "contractStarted": "Prenumerationen startade",
            "contractEnded": "Prenumerationen upphörde",
            "upgradeAnyTime": "Uppgradera när du vill",
            "devicesTitle": "Mina tidigare enheter",
            "flexTitle": "Dina enheter med Full Flex",
            "imeiCopy": "IMEI kopierat",
            "viewContract": "Se avtal",
            "viewInvoices": "Visa fakturor",
            "manageSubscription": "Hantera min enhet",
            "addNewSubscription": "Lägg till ny enhet",
            "addNewSubscriptionLink": "https://shop.samsung.com/se/",
            "swapService": "Swap service",
            "insuranceService": "Skapa försäkringsärende",
            "deviceDamagedConditionTermsLink": "https://resellers.foxway.com/subscriptionterms-se",
            "deviceDamagedConditionTerms": "<0>Om Enheten skadas eller försvinner måste du ersätta Foxway för den skada som orsakats. För oavsiktliga tapp- och vattenskador betalar du en begränsad skadeavgift för att få en ersättningsenhet. Avgiften varierar beroende på vilken modell du har. Fyll i frågorna nedan för att anmäla en skada och få Foxways bedömning om din skada kvalificerar dig för en Swap service.</0><1>Om din enhet blir stulen eller tappas bort erbjuder Foxway dig att betala en avgift för att ersätta telefonen. Avgiften motsvarar marknadsvärde vid tidpunkten. Kontakta kundservice för att anmäla en borttappad telefon.</1><2>Se fullständiga villkor för Swap service här</2>",
            "subscriptionsTitle": "Mina enheter",
            "valueTitle": "Dina enheter med 24 Mån",
            "nickname": {
                "title": "Ändra",
                "nickname": "Namn",
                "description": "Du kan lägga till en kort beskrivning till en enhet för att kunna hålla reda på vilken som är vilken om du har flera. Du kan döpa den till vad som helst, t.ex. “Lasses lur”."
            },
            "payPendingPayment": "Betala",
            "pendingPaymentsTitle": "Väntar",
            "tags": {
                "upgradeTo": "Uppgraderar till",
                "upgradeFor": "Levereras för att ersätta",
                "beingDelivered": "Levereras",
                "pendingPayment": "Undertecknat, men betalning väntar"
            },
            "cancel": {
                "title": "Avsluta Samsung Flex",
                "bolttech": {
                    "title": "Avsluta Samsung Flex",
                    "deviceDamagedConditionTerms": "<0>Om enheten skadas eller försvinner behöver du ersätta Lisa& för skadan som orsakats. I Samsung Flex ingår försäkringen Samsung Care+ som täcker oavsiktliga tapp- och vattenskador och då ska ett försäkringsärende skapas. För vissa andra skador kan Samsungs garanti tillämpas.</0><1>Fyll i formuläret för att få hjälp att identifiera hur ditt problem bäst löses.</1>",
                    "submitButton": "Gå vidare",
                    "continueButton": "Gå vidare",
                    "fellAndBrokeNotificationTitle": "Din skada är av den art som normalt täcks av Samsung Care+.",
                    "fellAndBrokeNotificationContent": "Gå vidare för att skapa ett försäkringsärende hos försäkringsbolaget.",
                    "lostOrStolenNotificationTitle": "Förlust av enhet täcks inte av försäkringen.",
                    "lostOrStolenNotificationContent": "Kontakta vår support för mer information.",
                    "stoppedWorkingNotificationTitle": "Ditt problem täcks inte av försäkringen, men kan omfattas av garantin.",
                    "stoppedWorkingNotificationContent": "Kontakta vår support för mer information.",
                    "damageSpecTitle": "Vänligen ladda upp bilder som visar enhetens skick",
                    "specificDamage": {
                        "frontScreen": "Framsidan",
                        "frontScreenDescription": "Ladda upp bild(er) som visar enhetens framsida och huvudskärm",
                        "backSide": "Baksidan",
                        "backSideDescription": "Ladda upp bild(er) som visar enhetens baksida"
                    }
                },
                "unavailableNotification": {
                    "title": "Avbryter din prenumeration",
                    "content": "Din beställning kan inte annulleras just nu. Kontakta vår support för mer information.",
                    "linkText": "",
                    "linkUrl": "",
                    "automaticClaim": "Din Samsung Flex prenumeration löper snart ut. Vi har redan påbörjat den automatiska uppsägningen, och du bör få ett returkit snart. Vill du uppgradera till en ny enhet? Gå till Samsung.com och beställ din nya enhet. Välj att uppgradera din befintliga enhet under utcheckningen. Om du vill behålla enheten, vänligen kontakta vår support för ett utköpserbjudande."
                },
                "receipt": {
                    "title": "Swap service med Ärende-ID {{id}} är registrerad",
                    "content": "Du kan se status för pågående Swap service under Mina enheter/nNär ditt ärende behandlats skickas en ersättningsenhet till dig tillsammans med ett returkit du använder för att returnera den skadade enheten till Foxway som tar hand om den på bästa sätt./nTänk på:/n1. Om möjligt, återställ din enhet till fabriksinställningar, radera all information och ta bort ditt Google konto från den skadade enheten/n2. Den skadade enheten ska vara returnerad inom 14 dagar från att du får din ersättningsenhet. Om du inte skulle returnera din enhet kan Foxway komma att fakturera dig för ersättningsenhetens marknadsvärde.",
                    "button": "Tillbaka till Startsida"
                },
                "keepDisclaimerTitle": "Jag vill lämna tillbaka enheten",
                "keepDisclaimerContent": "Om du vill behålla din enhet bör du kontakta kundsupport.",
                "upgradeDisclaimerLink": "Hantera denna prenumeration",
                "upgradeDisclaimerTitle": "Vill du uppgradera till en ny enhet?",
                "upgradeDisclaimerContent": "För att uppdatera din enhet måste du gå tillbaka till sidan 'hantera mina prenumerationer'.",
                "stateChoice": {
                    "title": "Vill du behålla, återställa eller uppgradera din enhet?",
                    "returnDevice": "Jag vill lämna tillbaka enheten",
                    "keepDevice": "Jag vill behålla enheten",
                    "upgradeDevice": "Jag vill uppgradera min enhet"
                },
                "invoicesDisclaimerTitle": "Utestående fakturor",
                "invoicesDisclaimerContent": "Du har obetalda fakturor, observera att alla fakturor måste betalas innan annulleringen genomförs.",
                "errors": {
                    "frontSideDamageFiles": "Ladda upp en bild på framsidan av enheten",
                    "backSideDamageFiles": "Ladda upp ett foto på baksidan av enheten"
                },
                "claimStatus": {
                    "pending": "Avbokning skickad",
                    "approved": "Avbokning godkänd",
                    "declined": "Avbokning avvisades",
                    "completed": "Avbokningen slutförd",
                    "sent": "Return Kit skickat",
                    "waitingForPayment": "Har utestående fakturor",
                    "paymentReceived": "Payment received",
                    "deviceReceived": "Enhet mottagen",
                    "deviceReceivedDamaged": "Enheten mottogs skadad"
                },
                "guide": {
                    "FLEX": {
                        "title": "Vill du avsluta Samsung Flex?",
                        "action": "Avsluta tjänsten",
                        "image": "https://dcosix8as1189.cloudfront.net/imagestorage/VendorImages/Upgrade_section_header.png",
                        "content": [
                            "Med Full Flex kan du säga upp ditt avtal när som helst. Tjänsten avslutas sista dagen i innevarande månad från uppsägning och du betalar för tjänsten månaden ut. Du får ett returkit hemskickat till dig som du ska använda för att returnera din enhet. När månaden har löpt ut har du 14 dagar på dig att lämna tillbaka enheten.\n\nTänk på att:\n<ul><li> Återställ din enhet till fabriksinställningar, radera all information och ta bort ditt Google konto från din enhet innan du skickar in den.</li><li> Outnyttjade rabatter på ditt nuvarande Samsung Flex avtal upphör vid uppsägning.</li><li> Om enheten är skadad behöver du ersätta Foxway för den skada som orsakats. För oavsiktliga tapp- och vattenskador betalar du en begränsad skadeavgift.</li><li> Fakturering återupptas för din enhet om den inte är returnerad inom 14 dagar efter att innevarande månad vid uppsägningstillfället har löpt ut.</li></ul>"
                        ],
                        "bolttech": {
                            "content": [
                                "Med Full Flex kan du säga upp ditt avtal när som helst. Tjänsten avslutas sista dagen i innevarande månad från uppsägning och du betalar för tjänsten månaden ut. Du får ett returkit hemskickat till dig som du ska använda för att returnera din enhet. När månaden har löpt ut har du 14 dagar på dig att lämna tillbaka enheten.\n\nTänk på att:\n<ul><li> Återställ din enhet till fabriksinställningar, radera all information och ta bort ditt Google konto från din enhet innan du skickar in den.</li><li>Outnyttjade rabatter på ditt nuvarande Samsung Flex avtal upphör vid uppsägning.</li><li>Enheten ska lämnas tillbaka i gott skick där normalt slitage är ok. Om enheten skadas behöver du ersätta Lisa& för skadan som orsakats. Oavsiktliga tapp- och vattenskador täcks av försäkringen som ingår och då ska ett försäkringsärende skapas för bedömning av försäkringsbolaget. För vissa andra skador kan Samsungs garanti tillämpas.</li><li> Fakturering återupptas för din enhet om den inte är returnerad inom 14 dagar efter att innevarande månad vid uppsägningstillfället har löpt ut.</li></ul>"
                            ]
                        },
                        "stepsTitle": "Så här fungerar det, steg för steg",
                        "steps": [
                            "Klicka på avsluta och följ instruktionerna. Du får nu svara på frågor om skicket på din enhet. När du slutfört uppsägningen av tjänsten skickar vi returkit hem till dig.",
                            "När du slutfört uppsägningen av tjänsten skickas ett returkit hem till dig.",
                            "Radera all information och ta bort ditt Google-konto på den gamla enheten.",
                            "Packa den gamla enheten noggrant och lämna den hos närmaste postombud."
                        ],
                        "eligibleNotificationText": "För att säga upp ditt kontrakt under de första {{days}} dagarna, vänligen kontakta Samsung."
                    },
                    "VALUE": {
                        "title": "Vill du avsluta Samsung Flex?",
                        "action": "Avsluta tjänsten",
                        "image": "https://dcosix8as1189.cloudfront.net/imagestorage/VendorImages/Upgrade_section_header.png",
                        "content": [
                            "Med 24 Mån kan du välja att avsluta tjänsten och skicka tillbaka din enhet, eller avsluta och betala en avgift för att köpa loss den om du önskar att behålla den efter avtalsperioden.\nDu kan göra ditt väl här i kundportalen en månad innan avtalstiden går ut. Gör du inget akivt val avslutas tjänsten automatiskt och du behöver returnera din enhet. När enheten ska återlämnas skickar Foxway ett returkit till dig som du använder för att returnera din enhet.\nÖnskar du att avsluta i förtid kontakta kundservice så hjälper vi dig.\n\nTänk på att:\n<ul><li>Återställ din enhet till fabriksinställningar, radera all information och ta bort ditt Google konto</li><li>Om enheten är skadad behöver du ersätta Foxway för den skada som orsakats. För oavsiktliga tapp- och vattenskador betalar du endast en begränsad skadeavgift.</li><li> Om din enhet inte är returnerad inom 14 dagar efter att avtalsperioden löpt ut kommer du att faktureras en avgift för att kompensera Foxway för den ej återlämnade enheten.</li></ul>"
                        ],
                        "bolttech": {
                            "content": [
                                "Med 24 Mån kan du välja att avsluta tjänsten och skicka tillbaka din enhet eller uppgradera till en ny enhet  vid slutet av kontraktsperioden. Gör du inget aktivt val avslutas tjänsten automatiskt och du behöver returnera enheten. När enheten ska återlämnas skickar Foxway ett returkit till di,g som du använder för att returnera din enhet.\nÖnskar du att avsluta i förtid kontakta kundservice så hjälper vi dig.\n\nTänk på att:\n<ul><li>Återställ din enhet till fabriksinställningar, radera all information och ta bort ditt Google konto</li><li>Enheten ska lämnas tillbaka i gott skick där normalt slitage är ok. Om enheten skadas behöver du ersätta Lisa& för skadan som orsakats. Oavsiktliga tapp- och vattenskador täcks av försäkringen som ingår och då ska ett försäkringsärende skapas för bedömning av försäkringsbolaget. För vissa andra skador kan Samsungs garanti tillämpas.</li><li> Om din enhet inte är returnerad inom 14 dagar efter att avtalsperioden löpt ut kommer du att faktureras en avgift för att kompensera för den ej återlämnade enheten.</li></ul>"
                            ]
                        },
                        "stepsTitle": "Så här fungerar det",
                        "steps": [
                            "Klicka på avsluta tjänsten och följ instruktionerna. Det är möjligt att göra ditt val en månad innan avtalsperioden löper ut.",
                            "Har du valt att avsluta och returnera (eller inte gjort något val alls) kommer du att få ett returkit hem till dig. Hör av dig till oss om du inte fått något när avtalsperioden löpt ut. Har du valt att köpa loss din enhet kommer du faktureras en avgift på kommande faktura.",
                            "Radera all information och ta bort ditt Google-konto",
                            " Packa din enhet noggrant och lämna den hos närmaste postombud"
                        ],
                        "eligibleNotificationText": "För att säga upp ditt kontrakt under de första {{days}} dagarna, vänligen kontakta Samsung."
                    }
                },
                "disclaimer": {
                    "flex": {
                        "title": "Tänk på följande när du avslutar Samsung Flex, Full Flex:",
                        "content": [
                            "Återställ din enhet till fabriksinställningar, radera all information och ta bort ditt Google-konto.",
                            "Outnyttjade rabatter i ditt nuvarande Samsung Flex avtal upphör vid uppsägning.",
                            "Om enheten är skadad, stulen eller borttappad behöver du ersätta Foxway för den skada som orsakats. För oavsiktliga tapp- och vattenskador betalar du endast en begränsad skadeavgift.",
                            "Fakturering återupptas för din enhet om den inte är returnerad inom 14 dagar efter att innevarande månad vid uppsägningstillfället  har löpt ut."
                        ],
                        "bolttech": {
                            "content": [
                                "Återställ din enhet till fabriksinställningar, radera all information och ta bort ditt Google-konto.",
                                "Outnyttjade rabatter i ditt nuvarande Samsung Flex avtal upphör vid uppsägning.",
                                "Om enheten är skadad, stulen eller försvunnen behöver du kompensera Lisa& för den skada som orsakats. Samsung Flex inkluderar en försäkring som täcker vatten och olycksfallsskador. Följ instruktionerna för att slutföra din uppsägning och registrera ett försäkringsärende om du har en sådan skada.",
                                "Fakturering återupptas för din enhet om den inte är returnerad inom 14 dagar efter att innevarande månad vid uppsägningstillfället  har löpt ut."
                            ]
                        }
                    },
                    "value": {
                        "title": "Tänk på följande när du avslutar din Samsung Flex 24 Månader:",
                        "content": [
                            "Återställ din enhet till fabriksinställningar, radera all information och ta bort ditt Google konto från din enhet innan du skickar in enhet.",
                            "Om enheten är skadad eller har försvunnit behöver du ersätta Foxway för den skada som orsakats. För oavsiktliga tapp- och vattenskador betalar du endast en begränsad skadeavgift. Se fullständiga villkor.",
                            "Om din gamla enhet inte är returnerad inom 14 dagar efter att avtalsperioden löpt ut kommer du att faktureras en avgift för att kompensera Foxway för den ej återlämnade enheten."
                        ],
                        "bolttech": {
                            "content": [
                                "Återställ din enhet till fabriksinställningar, radera all information och ta bort ditt Google konto från din enhet innan du skickar in enhet.",
                                "Enheten ska lämnas tillbaka i gott skick där normalt slitage är ok. Om enheten skadas behöver du ersätta Lisa& för skadan som orsakats. Oavsiktliga tapp- och vattenskador täcks av försäkringen som ingår och då ska ett försäkringsärende skapas för bedömning av försäkringsbolaget. Följ instruktionerna i nästa steg för att gå vidare.",
                                "Om din enhet inte är returnerad inom 14 dagar efter att avtalsperioden löpt ut kommer du att faktureras en avgift för att kompensera för den ej återlämnade enheten."
                            ]
                        }
                    }
                },
                "formTitle": "Vi behöver fler uppgifter innan du avslutar",
                "conditionChoice": "Är enheten i bra skick?",
                "conditionsButton": "Visa mer",
                "noDamage": "Ja, enheten är i bra skick, fungerar och har inga skador. Normalt slitage och kosmetiska skador som t.ex. repor som inte påverakar funktionaliteten räknas inte som skada.",
                "noDamageDescription": "",
                "hasDamage": "Nej, enheten är skadad alternativt stulen eller försvunnen ",
                "hasDamageDescription": "",
                "damageTitle": "Beskriv vad som har hänt med din enhet",
                "damageAdditionalTitle": "Ha bilder på skadan redo (framsida, baksida, öppen). Du kommer att ombes att ladda upp dem nedan.",
                "damageDate": "När inträffade skadan?",
                "damageDatePlaceholder": "Välj datum",
                "nextMonth": "Nästa månad",
                "prevMonth": "Förra månaden",
                "damageDescription": "Beskriv vad som har hänt med din enhet",
                "damageDescriptionPlaceholder": "Beskriv vad som har hänt med din enhet",
                "damageSpecTitle": "Vänligen välj beskrivning som bäst stämmer in på skadan. Du kan välja flera alternativ.",
                "termsLabel": "Jag har läst och är införstådd med informationen ovan",
                "submitButton": "Bekräfta",
                "damageType": {
                    "placeholder": "Välj ett alternativ",
                    "fellAndBroke": "Min enhet har en oavsiktlig tapp- eller vattenskada",
                    "stoppedWorking": "Min enhet slutade fungera eller har annat tekniskt fel som orsakats utan påverkan",
                    "lostOrStolen": "Min enhet är stulen eller borttappad"
                },
                "specificDamage": {
                    "frontScreen": "Skärmskada - huvudskärm",
                    "frontScreenDescription": "Huvudskärmen (den största skärmen om enheten har flera skärmar) har en eller flera sprickor (Repa räknas inte som skada).",
                    "frontScreenAddFile": "Ladda upp foton",
                    "frontScreenFile": "Skärmskada - huvudskärm",
                    "frontScreenRemove": "Ta bort bilder på framskärmen",
                    "backSide": "Skada på baksida och/eller ramen",
                    "backSideDescription": "Baksidan och/eller ramen är sprucken eller böjd. (repa räknas inte som skada)",
                    "backSideAddFile": "Ladda upp foton",
                    "backSideFile": "Skada på baksida och/eller ramen",
                    "backSideRemove": "Ta bort bakgrundsbilden på skärmen",
                    "camera": "Skadad kamera",
                    "cameraDescription": "Kameran har en spricka, repa eller annan skada som påverkar kamerans funktion. (repa eller annan skada som inte påverkar kamerans funktion räknas inte som skada)",
                    "audio": "Ljudproblem",
                    "audioDescription": "Mikrofonen eller högtalaren fungerar inte, problem med ljudförvrängning",
                    "network": "Nätverks problem",
                    "networkDescription": "Enheten har problem med att ansluta till nätverket",
                    "power": "PÅ/AV-problem",
                    "powerDescription": "Kan inte slå på eller stänga av enheten",
                    "other": "Övrig",
                    "otherDescription": "Enheten har en annan typ av skada",
                    "otherDescriptionLabel": "Beskriv skadan i detalj",
                    "otherDescriptionPlaceholder": "Beskriv skadan"
                },
                "notSupportedNotificationTitle": "Stulna eller borttappade enheter kan inte avbrytas.",
                "notSupportedNotificationContent": "Kontakta vår support för mer information.",
                "warrantyNotificationTitle": "Det verkar som om ditt problem täcks av garantin.",
                "warrantyNotificationContent": "Kontakta vår support för mer information.",
                "upsell": {
                    "title": "Är du säker på att du vill avsluta?",
                    "content": "Vill du byta ut din enhet finns andra möjligheter.",
                    "options": {
                        "swap-device": "Jag vill uppgradera min enhet",
                        "cancel-sub": "Jag vill avsluta tjänsten",
                        "upgrade-device": "Jag vill anmäla skada och fortsätta använda Samsung Flex"
                    },
                    "confirmButton": "Bekräfta",
                    "closeButton": "Stäng"
                }
            },
            "upgrade": {
                "unavailableNotification": {
                    "title": "Uppdateringen är inte tillgänglig.",
                    "content": "Kontakta Samsungs kundsupport för mer information.",
                    "linkText": "",
                    "linkUrl": ""
                },
                "guide": {
                    "FLEX": {
                        "image": "https://dcosix8as1189.cloudfront.net/imagestorage/VendorImages/Upgrade_section_header2.png",
                        "title": "Vill du uppgradera eller byta till en ny enhet?",
                        "action": "Uppgradera",
                        "url": "https://samsung.com",
                        "content": [
                            "Med Full Flex kan du uppgradera eller byta enhet när du vill. Välj din nya enhet på samsung.com och beställ den med Samsung Flex. I nästa steg väljer du att uppgradera din existerande Samsung Flex-tjänst. När du genomfört beställningen ingår du ett nytt avtal inom ramen för Samsung Flex och du får din nya enhet levererad hem tillsammans med en returfraktsedel som ska användas för att skicka tillbaka den gamla enheten. Då kan du föra över allt innehåll till den nya enheten innan du skickar tillbaka den gamla. Du kommer att faktureras priset för den nya enheten från det att du tar emot den.\nTänk på att:\n<ul><li> Återställ din enhet till fabriksinställningar, radera all information och ta bort ditt Google konto innan du skickar in din enhet</li><li> Outnyttjade rabatter i ditt nuvarande Samsung Flex avtal upphör vid en uppgradering då du ingår ett nytt avtal. Eventuell rabatt för inbytesenhet förs däremot vidare till ditt nya avtal.</li><li> Om enheten är skadad behöver du ersätta Foxway för den skada som orsakats. För oavsiktliga tapp- och vattenskador betalar du en begränsad skadeavgift.</li><li> Fakturering återupptas för din nuvarande enhet om den inte är returnerad inom 14 dagar från att du har mottagit din nya enhet.</li></ul>"
                        ],
                        "bolttech": {
                            "content": [
                                "Med Full Flex kan du uppgradera eller byta enhet när du vill. Välj din nya enhet på samsung.com och beställ den med Samsung Flex. I nästa steg väljer du att uppgradera din existerande Samsung Flex-tjänst. När du genomfört beställningen ingår du ett nytt avtal inom ramen för Samsung Flex och du får din nya enhet levererad hem tillsammans med en returfraktsedel som ska användas för att skicka tillbaka den gamla enheten. Då kan du föra över allt innehåll till den nya enheten innan du skickar tillbaka den gamla. Du kommer att faktureras priset för den nya enheten från det att du tar emot den.\nTänk på att:\n<ul><li> Återställ din enhet till fabriksinställningar, radera all information och ta bort ditt Google konto innan du skickar in din enhet</li><li> Outnyttjade rabatter i ditt nuvarande Samsung Flex avtal upphör vid en uppgradering då du ingår ett nytt avtal. Eventuell rabatt för inbytesenhet förs däremot vidare till ditt nya avtal.</li><li>Enheten ska lämnas tillbaka i gott skick där normalt slitage är ok. Om enheten skadas behöver du ersätta Lisa& för skadan som orsakats. Oavsiktliga tapp- och vattenskador täcks av försäkringen som ingår och då ska ett försäkringsärende skapas för bedömning av försäkringsbolaget. För vissa andra skador kan Samsungs garanti tillämpas. </li><li> Fakturering återupptas för din nuvarande enhet om den inte är returnerad inom 14 dagar från att du har mottagit din nya enhet.</li></ul>"
                            ]
                        },
                        "stepsTitle": "Så här uppgraderar du steg för steg",
                        "steps": [
                            "Klicka på `Uppgradera` och välj din nya enhet på samsung.com.",
                            "Lägg till Samsung Flex och gå till kassan. Välj villkor för Samsung Flex som gäller för din nya enhet.",
                            "När du identifierar dig, får du som befintlig kund frågan om du vill uppgradera en nuvarande enhet. Välj den enhet du vill uppgradera.",
                            "Slutför beställningen och få din nya enhet levererad hem tillsammans med en returfraktsedel för den gamla enheten.",
                            "För över allt innehåll till den nya enheten. Radera sedan all information och ta bort ditt Google-konto på den gamla enheten.",
                            "Packa den gamla enheten noggrant och lämna den hos närmaste postombud. Du kan använda samma förpackning som din nya enhet kom i."
                        ]
                    },
                    "VALUE": {
                        "image": "https://dcosix8as1189.cloudfront.net/imagestorage/VendorImages/Upgrade_section_header2.png",
                        "title": "Vill du uppgradera till en ny enhet?",
                        "action": "Uppgradera",
                        "url": "https://samsung.com",
                        "content": [
                            "Är det dags att uppgradera? Med 24 Mån kan du uppgradera till en ny enhet när avtalsperioden löper ut. Det gör du genom att välja din nya enhet på samsung.com och beställa den med Samsung Flex. I nästa steg väljer du att uppgradera din existerande Samsung Flex-tjänst. Detta kan du göra från och med när en månad återstår av avtalsperioden.\nNär du genomfört beställningen får du din nya enhet levererad hem tillsammans med en returfraktsedel som ska användas för att skicka tillbaka den gamla enheten. Då kan du föra över allt innehåll till den nya enheten innan du skickar tillbaka den gamla.\n\nTänk på att:\n<ul><li> Återställ din enhet till fabriksinställningar, radera all information och ta bort ditt Google konto</li><li> Om enheten är skadad behöver du ersätta Foxway för den skada som orsakats. För oavsiktliga tapp- och vattenskador betalar du endast en begränsad skadeavgift.</li><li> Om din gamla enhet inte är returnerad inom 14 dagar efter att avtalsperioden löpt ut kommer du att faktureras en avgift för att kompensera Foxway för den ej återlämnade enheten.</li></ul>"
                        ],
                        "bolttech": {
                            "content": [
                                "Är det dags att uppgradera? Med 24 Mån kan du uppgradera till en ny enhet när avtalsperioden löper ut. Det gör du genom att välja din nya enhet på samsung.com och beställa den med Samsung Flex. I nästa steg väljer du att uppgradera din befintliga Samsung Flex-tjänst. Detta kan du göra från och med när en månad återstår av avtalsperioden.\nNär du genomfört beställningen får du din nya enhet levererad hem tillsammans med en returfraktsedel som ska användas för att skicka tillbaka den gamla enheten. Då kan du föra över allt innehåll till den nya enheten innan du skickar tillbaka den gamla.\n\nTänk på att:\n<ul><li> Återställ din enhet till fabriksinställningar, radera all information och ta bort ditt Google konto</li><li>Enheten ska lämnas tillbaka i gott skick där normalt slitage är ok. Om enheten skadas behöver du ersätta Lisa& för skadan som orsakats. Oavsiktliga tapp- och vattenskador täcks av försäkringen som ingår och då ska ett försäkringsärende skapas för bedömning av försäkringsbolaget. För vissa andra skador kan Samsungs garanti tillämpas. </li><li> Om din gamla enhet inte är returnerad inom 14 dagar efter att avtalsperioden löpt ut kommer du att faktureras en avgift för att kompensera Foxway för den ej återlämnade enheten.</li></ul>"
                            ]
                        },
                        "stepsTitle": "Så här uppgraderar du, steg för steg",
                        "steps": [
                            "Kontrollera din avtalsperiod. Med 24 månader kan du beställa en uppgradering från en månad före avtalsperioden löper ut.",
                            "Klicka på  'Uppgradera' och välj din nya enhet på samsung.com.",
                            "När du identifierar dig får du som befintlig kund frågan om du vill uppgradera en nuvarande enhet. Välj den enhet du vill uppgradera.",
                            "Slutför beställningen och få din nya enhet levererad hem tillsammans med en returfraktsedel för den gamla enheten.",
                            "För över allt innehåll till den nya enheten. Radera sedan all information och ta bort ditt Google-konto på den gamla enheten.",
                            "Packa den gamla enheten noggrant och lämna den hos närmaste postombud. Du kan använda samma förpackning som din nya enhet kom i."
                        ]
                    }
                }
            },
            "swap": {
                "unavailableNotification": {
                    "title": "Utbytestjänst är inte tillgänglig.",
                    "content": "Kontakta Samsungs kundsupport för mer information.",
                    "linkText": "",
                    "linkUrl": ""
                },
                "receipt": {
                    "title": "Swap service med Ärende-ID {{id}} är registrerad",
                    "content": "När ditt ärende har blivit hanterat och i det fall det blir godkänt kommer du få en faktura skickad till dig med Swap kostnaden. (Har du autogiro aktiverat kommer kostnaden att dras från ditt konto automatiskt.) Så fort betalningen är gjord skickas en utbytesenhet till dig tillsammans med ett returkit som du använder för att skicka tillbaka din skadade enhet till Foxway.",
                    "button": "Tillbaka Hem"
                },
                "paymentSuccess": {
                    "title": "Swap Service ärende {{id}}  är nu skapad och betald",
                    "content": "Du kan se dina pågående Swap Service-ärenden och deras status under <1>Mina Enheter</1><2>Ditt ärende kommer att hanteras inom 2 arbetsdagar.</2>",
                    "button": "Tillbaka Hem"
                },
                "paymentError": {
                    "title": "Swap Service ärende {{id}} är nu skapad men betalningen misslyckades",
                    "content": "Slutför betalningen för att kunna genomföra din Swap Service",
                    "button": "Betala"
                },
                "title": "Swap Service",
                "bolttech": {
                    "title": "Skapa försäkringsärende",
                    "deviceDamagedConditionTerms": "<0>Om enheten skadas eller försvinner behöver du ersätta Lisa& för skadan som orsakats. I Samsung Flex ingår försäkringen Samsung Care+ som täcker oavsiktliga tapp- och vattenskador och då ska ett försäkringsärende skapas. För vissa andra skador kan Samsungs garanti tillämpas.</0><1>Fyll i formuläret för att få hjälp att identifiera hur ditt problem bäst löses.</1>",
                    "submitButton": "Gå vidare",
                    "continueButton": "Gå vidare",
                    "fellAndBrokeNotificationTitle": "Din skada är av den typ som normalt täcks av Samsung Care+.",
                    "fellAndBrokeNotificationContent": "Gå vidare för att skapa ett försäkringsärende hos försäkringsbolaget.",
                    "stoppedWorkingNotificationTitle": "Ditt problem täcks inte av försäkringen, men kan omfattas av garantin.",
                    "stoppedWorkingNotificationContent": "Kontakta vår support för mer information.",
                    "lostOrStolenNotificationTitle": "Förlust av enhet täcks inte av försäkringen.",
                    "lostOrStolenNotificationContent": "Kontakta vår support för mer information."
                },
                "claimStatus": {
                    "pending": "Swap Service under granskning",
                    "approved": "Ny enhet skickad",
                    "declined": "Swap Service avvisades",
                    "completed": "Avbokningen slutförd",
                    "sent": "Return Kit skickat",
                    "waitingForPayment": "Har utestående fakturor",
                    "paymentReceived": "Betalning mottagen",
                    "deviceReceived": "Enhet mottagen",
                    "deviceReceivedDamaged": "Enheten mottogs skadad"
                },
                "formTitle": "Beskriv ditt ärende",
                "submitButton": "Registrera och betala",
                "registerButton": "Registrera ärende",
                "payButton": "Betala",
                "continueButton": "Fortsätt",
                "damageTitle": "Beskriv vad som har hänt med din enhet",
                "damageAdditionalTitle": "Ha bilder på skadan redo (framsida, baksida, öppen). Du kommer att ombes att ladda upp dem nedan.",
                "damageDate": "När inträffade skadan?",
                "damageDatePlaceholder": "Välj datum",
                "nextMonth": "Nästa månad",
                "prevMonth": "Förra månaden",
                "damageDescription": "Beskriv vad som har hänt med din enhet",
                "damageDescriptionPlaceholder": "Beskriv händelsen",
                "damageSpecTitle": "Vänligen välj beskrivning som bäst stämmer in på skadan. Du kan välja flera alternativ.",
                "termsLabel": "Jag har läst och är införstådd med informationen ovan",
                "summaryTitle": "Ansökan om Swap service",
                "summary": {
                    "overview": {
                        "issues": {
                            "fell-and-broke": "Min enhet har en oavsiktlig tapp- eller vattenskada",
                            "lost": "Enhet förlorad eller stulen"
                        }
                    },
                    "returnKitSentNotificationTitle": "Notera",
                    "returnKitSentNotificationContent": "Vi kommer att skicka ett returkit för att hjälpa dig att returnera enheten.",
                    "returnKitSentNotificationLink": "#",
                    "returnKitSentNotificationLinkText": "",
                    "accordionTitle": "Ansökan om Swap service",
                    "certificateTitle": "Ärende-ID",
                    "productTitle": "Produkt",
                    "customerTitle": "Kundens namn",
                    "periodTitle": "Beställningens startdatum",
                    "deviceDetailsTitle": "Enhetsdetaljer",
                    "overviewTitle": "Ärendeöversikt",
                    "overviewIssueTitle": "Typ av skada",
                    "overviewDamageDescriptionTitle": "Beskrivning",
                    "overviewDateTitle": "Skadedatum",
                    "overviewDamagesTitle": "Skador",
                    "front-side": "Skärmskada - huvudskärm",
                    "back-side": "Skada på baksida och/eller ramen",
                    "camera": "Skadad kamera",
                    "audio": "Ljudproblem",
                    "network": "Nätverks problem",
                    "on-off-problem": "PÅ/AV-problem",
                    "other": "Övrig"
                },
                "notSupportedNotificationTitle": "Förlust av enhet täcks inte av Swap Service, kostnaden kommer att variera beroende på enhet.",
                "notSupportedNotificationContent": "Tap av enhet dekkes ikke av Swap Service, kostnadene vil variere avhengig av enheten.",
                "warrantyNotificationTitle": "Det verkar som om ditt problem täcks av garantin.",
                "warrantyNotificationContent": "Kontakta vår support för mer information."
            }
        },
        "privacyPolicy": {
            "title": "Cookie- och datainformationspolicy",
            "sections": [
                {
                    "title": "1. Användning av cookies och databehandling",
                    "content": "Foxway och dess partners, inklusive vår finansiella partner Lisa& Friends AB (registrerad i Sverige under organisationsnummer 934431650, med registrerad adress på c/o United Spaces, Drottninggatan 32, 111 51 Stockholm, Sverige), använder cookies och liknande teknologier (\"Teknologier\") för att lagra och få tillgång till information på din enhet.\n\nDessa teknologier är nödvändiga för att tillhandahålla säkra och funktionella tjänster, inklusive kassaprocesser och kundportalens funktioner. Genom att acceptera cookies samtycker du till behandlingen av dina data, inklusive delning av relevant information med Lisa& Friends AB för att underlätta finansiella tjänster och säkerställa en smidig upplevelse. Du kan hitta mer information om vår datadelning i vår <a href=\"https://www.foxway.com/sv/privacy-policy/\" target=\"_blank\" rel=\"noopener noreferrer\">integritetspolicy</a>."
                },
                {
                    "title": "2. Typer av cookies vi använder",
                    "content": "Vi använder både nödvändiga och valfria cookies för att förbättra din upplevelse. Dessa inkluderar:",
                    "items": [
                        "Strikt nödvändiga cookies – Krävs för grundläggande webbplatsfunktionalitet, inklusive säkerhet och tillgänglighet.",
                        "Prestanda- och analyscookies – Hjälper oss att analysera hur vår webbplats används för att förbättra användbarhet och prestanda.",
                        "Marknadsförings- och reklamcookies – Möjliggör personliga annonser och marknadsföringskampanjer, inklusive på tredjepartsplattformar."
                    ]
                },
                {
                    "title": "3. Hantera dina cookie-inställningar",
                    "content": "Du kan hantera dina cookie-inställningar när som helst:",
                    "items": [
                        "Acceptera alla cookies – Aktiverar full funktionalitet, inklusive personligt innehåll och marknadsföring.",
                        "Avvisa icke-nödvändiga cookies – Tillåter endast strikt nödvändiga cookies.",
                        "Anpassa inställningar – Justera specifika cookie-inställningar baserat på kategorier."
                    ],
                    "footer": "Du kan ändra dina samtyckesinställningar när som helst genom att klicka på \"Anpassa cookies\" längst ner på vår webbplats.\n\nFör mer information om hur Foxway behandlar dina data, vänligen se vår <a href=\"https://www.foxway.com/sv/privacy-policy/\" target=\"_blank\" rel=\"noopener noreferrer\">integritetspolicy</a>."
                }
            ]
        },
        "sessionExpires": {
            "title": "Sessionen löpte",
            "description": "Vill du förlänga sessionen?",
            "continueButtonText": "Fortsätta",
            "cancelButtonText": "Logga ut nu"
        }
    }
}
